import FORM_LABELS from "@/store/FormLabels";
import CONSTANTS from "@/store/constants";
import { mapGetters } from 'vuex'


export default {
    data() {
        return {
            // advancedPaymentOptions contains a displayForm Property, which on true would enable that route to be popped in Submit Payment Modal, and vice versa, and thus also helps in validating
            // user role accordingly for current user to display the Webform based on permissions.
            advancedPaymentOptions: [
                {
                    question: FORM_LABELS.PO_BASED_FORM_TITLE,
                    description: FORM_LABELS.PO_BASED_PAYMENT_DESC,
                    routeTo: CONSTANTS.PO_BASED_PAYMENT_FORM,
                    allowedDepartments: [CONSTANTS.ALLOW_ALL_DEPARTMENTS],
                    displayForm: true
                },
                {
                    question: FORM_LABELS.PO_BASED_FORM_TITLE,
                    description: FORM_LABELS.PO_BASED_PAYMENT_DESC,
                    routeTo: CONSTANTS.DRAFT_PO_BASED_PAYMENT_FORM,
                    allowedDepartments: [CONSTANTS.ALLOW_ALL_DEPARTMENTS],
                    displayForm: false
                },
                {
                    question: FORM_LABELS.PO_BASED_FORM_TITLE,
                    description: FORM_LABELS.PO_BASED_PAYMENT_DESC,
                    routeTo: CONSTANTS.COPY_PO_BASED_PAYMENT_FORM,
                    allowedDepartments: [CONSTANTS.ALLOW_ALL_DEPARTMENTS],
                    displayForm: false,
                },
                {
                    question: FORM_LABELS.ADV_PO_BASED_FORM_TITLE,
                    description: FORM_LABELS.ADVANCE_PO_PAYMENT_DESC,
                    routeTo: CONSTANTS.ADV_PO_BASED_PAYMENT_FORM,
                    allowedDepartments: [CONSTANTS.ALLOW_ALL_DEPARTMENTS],
                    displayForm: false
                },
                {
                    question: FORM_LABELS.NON_PO_TITLE,
                    description: FORM_LABELS.NON_PO_PAYMENT_DESC,
                    routeTo: CONSTANTS.NON_PO_PAYMENT_FORM,
                    allowedDepartments: [CONSTANTS.ALLOW_ALL_DEPARTMENTS],
                    displayForm: true
                },
                {
                    question: FORM_LABELS.NON_PO_TITLE,
                    description: FORM_LABELS.NON_PO_PAYMENT_DESC,
                    routeTo: CONSTANTS.DRAFT_NON_PO_BASED_PAYMENT_FORM,
                    allowedDepartments: [CONSTANTS.ALLOW_ALL_DEPARTMENTS],
                    displayForm: false
                },
                {
                    question: FORM_LABELS.NON_PO_TITLE,
                    description: FORM_LABELS.NON_PO_PAYMENT_DESC,
                    routeTo: CONSTANTS.COPY_NON_PO_BASED_PAYMENT_FORM,
                    allowedDepartments: [CONSTANTS.ALLOW_ALL_DEPARTMENTS],
                    displayForm: false,
                }
            ],
        }
    },
    computed: {
        ...mapGetters(["currentUser"])
    },
    methods: {
        validateUserRole() {
            let matchedRoute = this.advancedPaymentOptions.find(route => route.routeTo === this.$route.name)
            if (!matchedRoute.allowedDepartments.includes(this.currentUser.department)
                && !this.currentUser.authorities.includes(CONSTANTS.SUPPLIER_CENTRAL_ADMIN_ROLE) && !matchedRoute.allowedDepartments.includes(CONSTANTS.ALLOW_ALL_DEPARTMENTS)) {
                this.$router.push({name: "Forbidden"})
            }
        },
        validateAccessByFormType(formType) {
            let data = this.advancedPaymentOptions.find(form => form.formType === formType)
            if (data) {
                return (this.currentUser.authorities.includes(CONSTANTS.SUPPLIER_CENTRAL_ADMIN_ROLE) || data.allowedDepartments.includes(this.currentUser.department) || data.allowedDepartments.includes(CONSTANTS.ALLOW_ALL_DEPARTMENTS))
            }
            return false
        }
    }
}